import { NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

function TopicsDropdown({ navExpanded, setNavExpanded }) {
  const [show, setShow] = useState(false);
  const [topicsList, setTopicsList] = useState([]);
  const [topicsLoading, setTopicsLoading] = useState(true);
  const [topicsError, setTopicsError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const urlCat = new URLSearchParams(location.search).get('category') || '';

  const toggleDropdown = (e) => {
    e.preventDefault();       // prevent default link click
    setShow(prev => !prev);   // toggle dropdown open/close
  };

  // Fetch topics
  useEffect(() => {
    let mounted = true;

    const loadTopics = async () => {
      try {
        const base = (process.env.REACT_APP_BACKEND_API || "").trim();
        if (!base) throw new Error("REACT_APP_BACKEND_API not configured");
        const res = await fetch(`${base.replace(/\/$/, "")}/categories/`);
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
        const data = await res.json();
        if (mounted) {
          const normalized = data.map((c) => ({
            id: c.id,
            name: c.name || c.title || c.category_name || c.category || "Unnamed",
            slug: c.slug || (c.name && c.name.toLowerCase().replace(/\s+/g, "-")) || "",
          }));
          setTopicsList(normalized);
        }
      } catch (err) {
        if (mounted) setTopicsError(err.message);
      } finally {
        if (mounted) setTopicsLoading(false);
      }
    };

    loadTopics();

    const handleTopicUpdate = () => {
      loadTopics();
    };

    window.addEventListener('topicsUpdated', handleTopicUpdate);

    return () => {
      mounted = false;
      window.removeEventListener('topicsUpdated', handleTopicUpdate);
    };
  }, []);

  return (
    <NavDropdown
      title="Topics"
      id="topics-dropdown"
      show={show}
      onClick={toggleDropdown} // <-- handle click on title
      onMouseLeave={() => setShow(false)} // Close dropdown when cursor leaves
      className={`custom-dropdown ${navExpanded ? "mobile-dropdown-active" : ""}`}
    >
      {topicsLoading ? (
        <NavDropdown.Item disabled>Loading...</NavDropdown.Item>
      ) : topicsError ? (
        <NavDropdown.Item disabled>Error: {topicsError}</NavDropdown.Item>
      ) : topicsList.length > 0 ? (
        topicsList.map((t) => {
          const tSlug = (t.slug || (t.name && t.name.toLowerCase().replace(/\s+/g, '-')) || '').toLowerCase();
          const tNameLower = (t.name || '').toLowerCase();
          const isActive = urlCat && (String(t.id) === urlCat || tSlug === urlCat.toLowerCase() || tNameLower === urlCat.toLowerCase());
          return (
            <NavDropdown.Item
              key={t.id || t.slug}
              onClick={() => {
                const params = new URLSearchParams();
                params.set('category', t.slug || t.name.toLowerCase());
                navigate(`/topics?${params.toString()}`);
                setShow(false);
                if (typeof setNavExpanded === 'function') setNavExpanded(false);
              }}
              className={isActive ? 'active-topic' : ''}
              style={{ alignItems: 'center' , padding: '8px 12px' }}
            >
              {t.name}
            </NavDropdown.Item>
          );
        })
      ) : (
        <NavDropdown.Item disabled>No topics</NavDropdown.Item>
      )}
    </NavDropdown>
  );
}

export default TopicsDropdown;
